<template>
  <v-card class="dealer-tech-cc">
    <v-container class="pa-6">
      <v-row>
        <v-col cols="12">
          <div class="d-flex flex-column">
            <div>{{ $t('dealer.chargify.dealerTechContactAdmin') }}</div>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <div class="d-flex justify-end">
            <v-btn @click="decline" :loading="localLogoutLoading">
              {{ $t('global.logout') }}
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'DealerTechCC',
  props: {
    localLogoutLoading: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    decline() {
      this.$emit('decline')
    },
  },
})
</script>
